<div class="subject-container">
  @if (!isEditing) {
  <div class="subject-display">
    <span class="subject-text">{{ subject }}</span>
    <mat-icon
      id="edit-alert-subject-icon"
      class="edit-icon"
      (click)="startEdit()"
      >edit</mat-icon
    >
  </div>
  } @if (isEditing) {
  <div class="subject-edit">
    <div class="input-wrapper">
      <div class="input-container">
        <input
          #subjectInput
          type="text"
          maxlength="300"
          [(ngModel)]="subject"
          (input)="handleInput($event)"
          (keyup)="saveEdit($event)"
          (blur)="cancelEdit()"
          [matTooltip]="'Subject cannot exceed 300 characters.'"
          matTooltipPosition="right"
          [matTooltipDisabled]="true"
          matTooltipClass="error-tooltip"
          #tooltip="matTooltip"
        />
        @if (isError) {
        <mat-icon class="error-icon">error</mat-icon>
        }
      </div>
      <div class="action-buttons-container">
        @if (subject.trim().length !== 0) {
        <mat-icon class="check-icon" (mousedown)="saveEdit($event)"
          >check</mat-icon
        >
        <mat-divider vertical></mat-divider>
        }
        <ng-container>
          <mat-icon class="close-icon" (mousedown)="cancelEdit()"
            >close</mat-icon
          >
        </ng-container>
      </div>
    </div>
  </div>
  }
</div>
